import { render, staticRenderFns } from "./IconInfoCircle.vue?vue&type=template&id=05b175b7&"
import script from "./IconInfoCircle.vue?vue&type=script&lang=ts&"
export * from "./IconInfoCircle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports